export default __webpack_public_path__ + "static/media/brinjal.25191816.png";